import { formatNativeDate } from "lib/date";

export const getReservationById = (reservations, id) => {
	return reservations.created.ids
		.concat(reservations.confirmed.ids)
		.map((id) => reservations.byId[id])
		.filter((r) => r._id === id)
		.map((r) => ({ ...r, id: r._id }));
};

// Select a reservation whose state is enqueued. Otherwise, return null.
/*
export const selectOngoingReservationByLineId = (myReservations, lineId) => {
	return myReservations.queued.reduce(
		(def, id) =>
			myReservations.byId[id].line_id === lineId
				? myReservations.byId[id]
				: def,
		null
	);
};
*/

/*
export const selectCreatedReservationByLineId = (myReservations, lineId) => {
	return myReservations.created.reduce(
		(def, id) =>
			myReservations.byId[id].line_id === lineId
				? myReservations.byId[id]
				: def,
		null
	);
};
*/

// this is for reservations v1
export const selectReservationQueue = (reservationQueue, lineId) => {
	if (!lineId) return {};
	return reservationQueue.reduce(
		(acc, r) => (r.line_id === lineId ? { ...r, ...acc } : acc),
		{}
	);
};

// Returns the number of available reservations
export const getAvailableReservations = (state, restriction, slug) => {
	if (restriction === null) return Infinity;
	//if (restriction === "unavailable") return 0;
	const filter = restriction === "office" ? "byOfficeSlug" : "byLineSlug";
	if (!state.settings[filter][slug]) return 0;

	return (
		state.settings[filter][slug].availableReservations -
		state.reserves.filter(
			(r) => r.lineSlug === slug || r.officeSlug === slug
		).length
	);
};

// returns true if there is a
export const selectEnqueuedReservations = (reservations, lineSlug) => {
	//if (!reservations.byId[lineSlug]) return null;
	return reservations.queued.ids.reduce(
		(d, r) => (r === lineSlug ? true : d),
		false
	);
};

// Returns type of the restriction by office slug
// Can be "office" | "line" | "all" | null
export const getOfficeRestriction = (state, officeSlug) => {
	if (!state.settings.byOfficeSlug[officeSlug])
		throw "office settings not loaded yet";
	return state.settings.byOfficeSlug[officeSlug].restrictionType;
};

// expects a native javascript Date object
export const selectTimeblocks = (timeblocks, slug, date) => {
	const d = formatNativeDate(date);
	if (!slug) return [];
	if (!timeblocks.byId[`${slug}-${d}`]) return [];
	return timeblocks.byId[`${slug}-${d}`];
};

export const selectCurrentReservation = (reservations) => {
	if (!reservations) return null;
	if (reservations.current.length === 0) return null;
	return reservations.current[0];
};

export const selectReservation = (reservations, reservationId) => {
	if (!reservationId) return null;
	return reservations.byId[reservationId.trim()];
};

export const selectActiveUserReservations = (reservations) => {
	return Object.values(reservations.byId)
		.filter((r) => !r.deleted)
		.filter((r) => !r.delete_at);
};

export const selectCurrentUserReservations = (reservations) => {
	// console.log(
	// 	"selectUserCreatedReservationsByLine -> reservations",
	// 	reservations
	// );
	return reservations;
	// const userReservations = reservations.filter(
	// 	({ cancelled_at, deleted_at }) => !cancelled_at || !deleted_at
	// );
	// return userReservations;
};

export const selectMyReservationsV1 = (reservations) =>
	Object.values(reservations.byId).filter((r) => !r.isV2);

export const selectReservationById = (myReservations) => {
	return myReservations.respald;
};
